import { NODE_TYPE } from '@/lib/nodeType';
import { ROUTES } from '@/lib/routes';

/*
    Здесь стоит добавлять ТОЛЬКО узлы дерева, от которых должен запускаться модуль.

    В идеале стоит обобщить эту конфигурацию и на списки, но сейчас есть кейсы,
    которые не позволяют ограничивать выбор скважин на уровне списков.
    Например, если ограничить запуск от скважины для модуля, где не требуется запуск от скважины,
    то нельзя будет через виджет дерева создать группу на основе скважины из списка.
*/

const PERMISSIONS = {
    [ROUTES.HOME]: {
        [NODE_TYPE.ORGANIZATION]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.AREA]: true,
        [NODE_TYPE.LICENSE]: true,
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.PAD]: true,
        [NODE_TYPE.KNS]: true,
    },

    [ROUTES.MINING_AND_PUMPING]: {
        [NODE_TYPE.FIELD]: true,
    },

    [ROUTES.SUMMARY_MODE]: {
        [NODE_TYPE.ORGANIZATION]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.DEVELOP]: true,
        [NODE_TYPE.PAD]: true,
        [NODE_TYPE.KNS]: true,
    },

    [ROUTES.TECHNOLOGICAL_EFFICIENCY_GTM]: {
        [NODE_TYPE.ORGANIZATION]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.FIELD]: true,
    },

    [ROUTES.WELL_LOGGING_OPERATIONS]: {},

    [ROUTES.MAP_GENERATION]: {
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.PAD]: true,
        [NODE_TYPE.OBJECT_DEV]: true,
        [NODE_TYPE.FIELD_F]: true,
        [NODE_TYPE.FIELD_A]: true,
        [NODE_TYPE.AREA]: true,
        [NODE_TYPE.ELEVATION]: true,
        [NODE_TYPE.AREA_A]: true,
        [NODE_TYPE.COMPANY_L]: true,
        [NODE_TYPE.FIELD_L]: true,
        [NODE_TYPE.LICENSE_L]: true,
        [NODE_TYPE.GROUP_INDUSTRIAL_FACILITY]: true,
        [NODE_TYPE.INDUSTRIAL_FACILITY]: true,
    },

    [ROUTES.DESATURATION_CHARACTERISTICS]: {
        [NODE_TYPE.ORGANIZATION]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.PAD]: true,
    },

    [ROUTES.OIL_PRODUCTION_LOSS]: {
        [NODE_TYPE.FIELD]: true,
    },

    [ROUTES.FACTOR_ANALYSIS]: {
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.PAD]: true,
    },

    [ROUTES.GSR]: {
        [NODE_TYPE.AREA]: true,
        [NODE_TYPE.LICENSE]: true,
        [NODE_TYPE.FIELD]: true,
    },

    [ROUTES.WELLS_VIEW]: {},

    [ROUTES.REPORTS]: {
        [NODE_TYPE.ORGANIZATION]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.AREA]: true,
        [NODE_TYPE.LICENSE]: true,
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.DEVELOP]: true,
        [NODE_TYPE.PAD]: true,
    },

    [ROUTES.MAP_WASM]: {
        [NODE_TYPE.FIELD]: true,
    },
    [ROUTES.GEOLAYERS]: {
        [NODE_TYPE.FIELD]: true,
        [NODE_TYPE.COMPANY]: true,
        [NODE_TYPE.PAD]: true,
        [NODE_TYPE.OBJECT_DEV]: true,
        [NODE_TYPE.FIELD_F]: true,
        [NODE_TYPE.FIELD_A]: true,
        [NODE_TYPE.AREA_A]: true,
        [NODE_TYPE.COMPANY_L]: true,
        [NODE_TYPE.FIELD_L]: true,
        [NODE_TYPE.LICENSE_L]: true,
        [NODE_TYPE.INDUSTRIAL_FACILITY]: true,
    },
};

export const isAllowNodeForModule = (moduleRoute, node) => {
    return Boolean(PERMISSIONS[moduleRoute]?.[node]);
};
